<template>
  <div>
    <Title title="稿件预览" :backShow2="backShow"/>
    <div class="Man_content">
      <div class="Man_content_title_box">
        <h4 class="title">{{ fill_form.title }}</h4>
        <p class="hint">提示：本平台所发布信息的内容和准确性由提供消息的原单位或组织独立承担完全责任!</p>
      </div>
      <div class="Man_content_1">
        <div class="Man_content_1_left">
          <div v-if="fill_form.content" class="Man_content_text"
               v-html="$options.filters.formatTitle(content, verifyArray)">
          </div>
        </div>
        <div class="Man_content_1_right">
          <span>素材上传状态</span>
          <div v-if="this.placard.fill_form.file!==''" class="uploaded">已上传</div>
          <div v-else class="notUploaded">未上传</div>
        </div>
      </div>
    </div>
    <div class="relevantQualifications_box">
      <el-divider content-position="left">相关资质</el-divider>
      <div class="relevantQualifications_content">
        <div class="Man_content_item" v-if="this.placard.fill_form.business_license_list.length !==0">
          <div class="Man_content_item_title">
            营业执照：
          </div>
          <el-image
              style="width: 150px; height: 115px"
              :src="this.placard.fill_form.business_license_list[0].url"
              :preview-src-list="[this.placard.fill_form.business_license_list[0].url]">
          </el-image>
          <!--          <img :src="this.placard.fill_form.business_license_list[0].url">-->
        </div>
        <div class="Man_content_item" v-if="this.placard.fill_form.shangbiao_zhengshu_list.length !==0">
          <div class="Man_content_item_title">
            商标证书：
          </div>
          <el-image
              style="width: 150px; height: 115px"
              :src="this.placard.fill_form.shangbiao_zhengshu_list[0].url"
              :preview-src-list="[this.placard.fill_form.shangbiao_zhengshu_list[0].url]">
          </el-image>
          <!--          <img :src="this.placard.fill_form.shangbiao_zhengshu_list[0].url">-->
        </div>
        <div class="line"
             v-if="this.placard.fill_form.business_license_list.length !==0 && this.placard.fill_form.shangbiao_zhengshu_list.length!==0 && this.placard.fill_form.qita_zizhi_list.length !==0"></div>
        <div class="Man_content_item" v-if="this.placard.fill_form.qita_zizhi_list.length !==0">
          <div class="Man_content_item_title">
            其他资质：
          </div>
          <div>
            <!--            <img :src="item.url" style="margin-right: 20px"-->
            <!--                 v-for="(item,index) in this.placard.fill_form.qita_zizhi_list">-->
            <el-image
                v-for="(item,index) in this.placard.fill_form.qita_zizhi_list"
                style="width: 150px; height: 115px;margin-right: 20px"
                :src="item.url"
                :preview-src-list="[item.url]">
            </el-image>
          </div>

        </div>
        <div
            v-if="this.placard.fill_form.business_license_list.length ===0 && this.placard.fill_form.shangbiao_zhengshu_list.length===0 && this.placard.fill_form.qita_zizhi_list.length ===0">
          <el-empty description="暂无" image-size="80" style="padding: 0;margin-left: 200px"></el-empty>
        </div>
      </div>

    </div>
    <!-- 广告的底部操作栏 -->
    <set_placard/>
  </div>
</template>

<script>
import Title from '@/components/UserInfoTitle'
import SetMenuButNav from '@/components/SetMenuButNav'
import set_placard from '@/components/set_placard'
import {mapState} from 'vuex'
import {timeCut} from '@/util/timeCut'
// import { goLink } from '@/util/goLink'
export default {
  mounted() {
    console.log('this.placard.fill_form', this.placard.fill_form)
    this.fill_form = this.placard.fill_form
    this.shop_car = this.placard.car_list
    this.content = JSON.parse(JSON.stringify(this.fill_form.content))
    // 效验文章是否有敏感字
    this.verifyTest()
    // console.log(this.$store.state.FillForm);
    if (this.fill_form.limit_time !== '') {
      this.limit_time = timeCut(this.fill_form.limit_time)
    }
    // 区分返回按钮
    this.backShow = 2
  },
  computed: {
    ...mapState(['FillForm', 'placard', 'shopObj', 'standing']),
  },
  components: {
    Title,
    SetMenuButNav,
    set_placard
  },
  data() {
    return {
      shop_car: [],
      fill_form: {
        cover_image: '', //封面
        title: '',
        content: '', //编译器内容
        limit_time: '', //时间选择器
        file: '',
        url: '',
        video_url: '',
        original_url: '', //原文链接
        remark: '',
        medium_ids: '',
        package_ids: '',
      },
      backShow: 1,
      content: '',
      limit_time: '',
      verifyArray: [],
    }
  },
  filters: {
    formatTitle(value, keyword) {
      if (!value) return '';
      // value = value.length > 30 ? value.substr(0, 29) + '...' : value; //标题超过30字符展示...
      if (Array.isArray(keyword)) {
        keyword.forEach((item) => {
          if (item && value.includes(item)) {
            var regex = RegExp('(' + item.replace('\\$1') + ')', 'ig');
            var html = '<span style="color:red;font-size="1em"" >' + item + '</span>';
            value = value.replace(regex, html)
          }
        })
      }
      return value;
    },
  },
  methods: {
    verifyTest() {
      if (this.$store.state.FillForm.content) {
        this.curlGet('/api/index/website').then(res => {
          res.data.data.sensitive_word.forEach((item, index) => {
            this.verifyArray.push(item)
          })
        })
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.title {
  .but {
    // width: 22rem !important;

    .back {
      width: 5.83rem;
      height: 2.5rem;
      background: #fff;
      color: #108CDD;
      border: 0;
      box-shadow: 0.17rem 0.17rem 0.33rem #000000;
      border-radius: 0.42rem;
      cursor: pointer;
    }

    .copy {
      width: 5.83rem;
      height: 2.8rem;
      border: 0;
      background: #108CDD;
      color: #fff;
      border: 0;
      border-radius: 0.42rem;
    }
  }
}

.Man_content {
  //min-height: 73vh;
  height: 450px;
  padding: 24px 30px;
  box-sizing: border-box;
  position: relative;
  z-index: 999;
  border-radius: 0.83rem;
  background: #ffffff;
  box-shadow: 0.17rem 0.17rem 0.33rem #7a7a7a;
  margin-top: 1rem;
  margin-bottom: 20px;

  .Man_content_1 {
    display: flex;

    .Man_content_1_left {
      flex: 1;
      margin-left: 150px;
      margin-top: 20px;
      //background-color: red;
      max-height: 330px;
      //overflow-y: scroll;
      overflow: auto;
    }

    .Man_content_1_right {
      //background-color: blue;
      width: 200px;
      height: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      span {
        font-size: 18px;
        margin-bottom: 50px;
      }

      .uploaded {
        width: 100px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: white;
        opacity: 1;
        border-radius: 5px;
        background: rgba(18, 204, 52, 1);
        font-size: 18px;
      }

      .notUploaded {
        width: 100px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: white;
        opacity: 1;
        border-radius: 5px;
        background: rgba(255, 0, 0, 1);
        font-size: 18px;
      }
    }
  }


}

.el-divider__text {
  font-weight: 700;
}

.Man_content_title_box {
  border-bottom: 0.08rem solid #aaaaaa;
  padding-bottom: 1rem;
  // margin-bottom: 1rem;
  box-sizing: border-box;

  .title {
    color: #333;
    font-size: 1.8rem;
    text-align: center;

  }
}

.Man_content_title {
  background: #E1F1FC;
  padding: 15px;
  box-sizing: border-box;
  color: #108CDD;
  font-size: 14px;

  span {
    cursor: pointer;
    color: #333;
    font-size: 14px;
    text-decoration: underline;
    padding-left: 5px;
  }

  i {
    font-style: normal;
    color: rgba(255, 0, 0, 1);
    font-size: 14px;

    &:first-child {
      margin-left: 10px;
    }
  }
}

.content_title {
  font-size: 16px;
  color: #333;
  margin: 10px 0 0 0;
}

.content {
  padding-top: 10px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 40px;

  ::v-deep p {
    // font-size: 1.22rem !important;
    color: #333;
  }
}

.relevantQualifications_box {
  width: 100%;
  height: 200px;
  border-radius: 0.83rem;
  background: #ffffff;
  box-shadow: 0.17rem 0.17rem 0.33rem #7a7a7a;
  display: flex;
  align-items: center;
  flex-direction: column;

  .relevantQualifications_content {
    width: 100%;
    display: flex;
    align-items: center;
    //justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;

    .Man_content_item_title {
      font-weight: 700;
    }

  }
}

.line {
  width: 1px;
  height: 100px;
  background-color: #DCDFE6;
  margin-right: 30px;
}

.Man_content_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 30px;


  img {
    width: 150px;
    height: 115px;
  }
}

.fillFormTime {
  color: #EF2626;
  font-size: 1.33rem;
  font-weight: bold;
  text-align: left;
}

.hint {
  color: #EF2626;
  font-size: 1.2rem;
  text-align: center;
}

.remark_box {
  background: #E1F1FC;
  padding: 1rem 0;
  max-height: 10rem;
  overflow-y: auto;
  font-size: 1.22rem;
  box-sizing: border-box;
}

.Man_content_text {
  color: #333;
  line-height: 35px;
  //background-color: red;

  ::v-deep p {
    font-size: 16px !important;
    color: #333;

    strong {
      font-size: 14px !important;
      color: #333;
    }
  }

}

.out_text {
  font-size: 14px;
  margin-bottom: 10px;
  align-items: center;

  span {
    color: #333;
  }

  a {
    display: block;
    width: 101px;
    height: 32px;
    line-height: 32px;
    border-radius: 10px;
    background: #0FA30F;
    color: #fff;
    text-decoration: none;
    text-align: center;
    margin-left: 10px;
  }
}
</style>